(($, Drupal) => {
  'use strict';
  Drupal.behaviors.video_trigger = {
    attach: function(context, settings) {
      let $video_modal_trigger = $('.remote-video-button');

      const buttonLoadVideo = function($btn) {
        const src = $btn.attr('data-src');
        const title = $btn.attr('data-title');
        const width = $btn.attr('width');
        const height = $btn.attr('height');
        const $iframe = $('<iframe allowfullscreen></iframe>');
        $iframe.attr('height', height);
        $iframe.attr('width', width);
        $iframe.attr('allow', 'autoplay');
        var symbol = src.indexOf('?') > -1 ? '&' : '?';
        $iframe.attr('src', src + symbol + 'autoplay=1');
        $iframe.attr('title', title);
        $iframe.attr('accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        $btn.replaceWith($iframe);
      };

      $video_modal_trigger.once('trigger-video').on('click', function() {
        const $btn = $(this);
        buttonLoadVideo($btn);
      });
    }
  };

  Drupal.behaviors.video_embed = {
    attach: function(context, settings) {
      let $drupalIframe = $('iframe.media-oembed-content', context);
      let $videoIframe = $('iframe', context);

      if ($videoIframe.length > 0 && ($videoIframe[0].src.startsWith('https://vimeo.com') || $videoIframe[0].src.startsWith('https://player.vimeo.com'))) {
        // eslint-disable-next-line no-undef
        let player = new Vimeo.Player($videoIframe);
        parent.document.addEventListener('play', function() {
          player.play();
        });
      }

      if ($drupalIframe.length > 0) {
        let $trigger = $('.remote-video-embed', context);
        let $target = $('.video-embed-wrapper', context);
        let playEvent = new CustomEvent('play');

        $trigger.on('click', function() {
          $trigger.addClass('hide');
          $target.removeClass('hide');
          document.dispatchEvent(playEvent);
        });
      }
    }
  };
})(jQuery, Drupal);
